import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { fetchBasket, setQuantity, setVoucherCode } from "actions/basket";
import { fetchCurrentStaff } from "actions/staffs";

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);

let _content = null;

const isBrandTfs = $A.BRAND === "TFS";

const Basket = (props) => {
  const { fetchBasket, setQuantity, setVoucherCode, fetchCurrentStaff } = props;
  const [voucherCodeData, setVoucherCodeData] = useState("");

  useEffect(() => {
    fetchBasket();
    fetchCurrentStaff();
  }, []);

  const setQuantityData = (quantity, product, attributes = {}) => {
    setQuantity(quantity, product, attributes);
  };

  const normalizeVoucher = (code) => {
    const trimmed = code.trim();
    return isBrandTfs && !trimmed.includes("|") ? `${trimmed}|` : trimmed;
  };

  const applyVoucherCode = (remove, voucherCodes) => {
    if (remove) {
      setVoucherCode("", true);
      setVoucherCodeData("");
      return;
    }

    let voucherCodeString = "";

    if (Array.isArray(voucherCodes)) {
      voucherCodeString = voucherCodes.map(normalizeVoucher).join(",");
    } else if (voucherCodes && typeof voucherCodes === "string") {
      voucherCodeString = normalizeVoucher(voucherCodes);
    }

    setVoucherCode(voucherCodeString.toUpperCase(), false);
  };

  const handleOnChangeVoucherCode = (voucher_code) => {
    setVoucherCodeData(voucher_code);
  };

  return (
    _content &&
    _content({
      props,
      voucherCodeData,
      setQuantityData,
      applyVoucherCode,
      handleOnChangeVoucherCode,
    })
  );
};

const mapStateToProps = (state) => ({
  basket: state.basket.basket,
  basketItems: state.basket.basketItems,
  customer: state.basket.customer,
  pending: state.basket.pending,
  error: state.basket.error,
  logged_in: state.basket.logged_in,
});

const mapDispatchToProps = {
  fetchBasket,
  setQuantity,
  setVoucherCode,
  fetchCurrentStaff,
};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(Basket);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/basket/index.js